import * as z from "zod/v4";

export const getSlaDateCounts = {
  name: "getSlaDateCounts" as const,
  input: z.object({
    merchantTimezone: z.string().nullish(),
    locationId: z.string().nullish(),
  }),
  output: z.object({
    overdue: z.number(),
    dueToday: z.number(),
    future: z.number(),
    overdueItems: z.number().nullish(),
    dueTodayItems: z.number().nullish(),
    futureItems: z.number().nullish(),
  }),
};
